import { Router, ActivatedRoute } from '@angular/router';
import { LayoutService } from '../../shared/services/layout.service';
import { delay } from 'rxjs/operators';
import { Component, HostListener } from '@angular/core';


// Page created by Kowsalya

@Component({
	selector: 'login-tnc',
	templateUrl: 'login-tnc.component.html'
})
export class LoginTnCComponent {
    showAgreeBtn : boolean;
    constructor(
        private _layoutService: LayoutService,
        private activeRoute: Router
	){}
    
   /* @HostListener("window:scroll", ["$event"])
    onWindowScroll() {
        let elem = document.getElementById("style-2");
        let pos = elem.scrollTop + elem.offsetHeight;  
        console.log(pos);
        pos = Math.floor(pos);
        let max = elem.scrollHeight;
        console.log(max,pos);
         if (pos >= max -3 ) {
            this.showAgreeBtn = false;
        }
        else{
            this.showAgreeBtn = true;
        }
    }*/
    ngOnInit(){
        this.showAgreeBtn = false;
        this._layoutService.setCurrentPage('login-tnc');
        /*if (this._layoutService.isLogout == 1)
        {
            document.getElementById('fibre-readiness-modals').style.display = 'none';
        }*///Kowsalya: commented during SIT
    }
    checkboxchange()
    {
        if(this.showAgreeBtn == false)
        {
            this.showAgreeBtn = true;
              
        }else{
            this.showAgreeBtn = false;
        }  
        //this._layoutService.tandc = true;//Kowsalya   
        //document.getElementById('fibre-readiness-modals').style.display = 'none';
        //setTimeout(()=>{ document.getElementById('fibre-readiness-modals').style.display = 'none', this._layoutService.vLayoutState.appPPMFlowHeader = true }, 1000);
    }
    //Added by Anjaiah
    disAgree(){
        this.activeRoute.navigate(['/home'])
    }
      //Added by Anjaiah
    agree(){
        //this._layoutService.tandc = true;//Kowsalya
        //document.getElementById('fibre-readiness-modals').style.display = 'none';
        setTimeout(()=>{ document.getElementById('fibre-readiness-modals').style.display = 'none', this._layoutService.vLayoutState.appPPMFlowHeader = true }, 1000);
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/configuration/login-tnc.component.ts